import { c as _c } from "react/compiler-runtime";
import './content-feed-avatar.scss';
import React from 'react';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
export interface ContentFeedAvatarProps {
  /** URL of the avatar image */
  src?: string;
  /** Accessible alt text for the image */
  alt: string;
  /** Initials to display when no image is available (e.g. "OR", "AW") */
  initials?: string;
  /** Size variant — 'sm' for reply-level avatars (24px), default is 42px */
  size?: 'default' | 'sm';
  /** Additional class names */
  className?: string;
}

/**
 * Circular avatar with photo, initials fallback, or generic icon fallback.
 * Default size is 42px. The 'sm' variant is 24px (used for reply thread avatars).
 */
export const ContentFeedAvatar: React.FC<ContentFeedAvatarProps> = t0 => {
  const $ = _c(26);
  const {
    src,
    alt,
    initials,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const sizeClass = size === "sm" ? "ContentFeedAvatar--sm" : undefined;
  if (src) {
    let t2;
    if ($[0] !== className || $[1] !== sizeClass) {
      t2 = cn("ContentFeedAvatar", sizeClass, className);
      $[0] = className;
      $[1] = sizeClass;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== alt || $[4] !== src || $[5] !== t2) {
      t3 = <img src={src} alt={alt} className={t2} loading="lazy" />;
      $[3] = alt;
      $[4] = src;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  if (initials) {
    let t2;
    if ($[7] !== className || $[8] !== sizeClass) {
      t2 = cn("ContentFeedAvatar ContentFeedAvatar--initials flex items-center justify-center", sizeClass, className);
      $[7] = className;
      $[8] = sizeClass;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    const t3 = size === "default";
    const t4 = size === "sm";
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
      t5 = cn("ContentFeedAvatar__initials", {
        "label-potent label-lg": t3,
        "label-potent label-sm": t4
      });
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== initials || $[14] !== t5) {
      t6 = <span className={t5}>{initials}</span>;
      $[13] = initials;
      $[14] = t5;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    let t7;
    if ($[16] !== alt || $[17] !== t2 || $[18] !== t6) {
      t7 = <div className={t2} aria-label={alt} role="img">{t6}</div>;
      $[16] = alt;
      $[17] = t2;
      $[18] = t6;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    return t7;
  }
  let t2;
  if ($[20] !== className || $[21] !== sizeClass) {
    t2 = cn("ContentFeedAvatar ContentFeedAvatar--placeholder flex items-center justify-center", sizeClass, className);
    $[20] = className;
    $[21] = sizeClass;
    $[22] = t2;
  } else {
    t2 = $[22];
  }
  let t3;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArkIcon iconName="user-circle" size="1.5em" />;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== t2) {
    t4 = <div className={t2} aria-hidden="true">{t3}</div>;
    $[24] = t2;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  return t4;
};